import { Button, Table,Spin, Input, Form, Card, Select, SelectProps} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {Col, Row } from 'react-bootstrap';
import {FileExcelOutlined, SearchOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import * as XLSX from 'xlsx';
import {AUTH_URL} from '../constants';
import { TfiReload } from 'react-icons/tfi';
import { DatePicker } from 'antd'
import moment, { Moment } from 'moment'
import dayjs, { Dayjs } from 'dayjs'
import {IClient, IIdType, IStatement} from '../factory/interfaces'
import { notify, notify_success } from '../pages/LoginPage'
import { toastStyle } from './Toaster'
import { PDFDownloadLink } from '@react-pdf/renderer'
import PDFViewer, { Transaction } from './commons/PDFViewer'
import { useSelector } from 'react-redux'
import { selectUserDetails } from '../features/auth/authSlice'
import { LiaDownloadSolid } from "react-icons/lia"



const { RangePicker } = DatePicker

const StatementTable = () => {
    const dispatch = useDispatch()
    const [dateRange, setDateRange]= useState<string[]>(['2024-03-17', '2024-05-20'])
    const momentArray: Moment[] = dateRange.map(date => moment(date))
    const [idTypes, setIdTypes]= useState<IIdType[]>()
    const [searching, setSearching]= useState(false)
    const [form] = Form.useForm()
    const [clients, setClients] = useState<SelectProps['options']>([])
    const [marchedClient, setMarchedClient]= useState<string>()
    const [client, setClient]= useState<IClient>()

    const userDetails = useSelector(selectUserDetails)



  type EventValue<T> = T | null

  // Convert moment array to Dayjs array
  const dayjsArray: Dayjs[] = momentArray.map(date => dayjs(date.toDate()));
      const valueArray: [EventValue<Dayjs>, EventValue<Dayjs>] = [
    dayjsArray[0] || undefined,
    dayjsArray[1] || undefined,
  ];

  
    const [transactions, setTransactions] = useState<IStatement[] | Transaction[]>()
    const [summary, setSummary] = useState<{ totalCredit: number; totalDebit: number, balance: Number }>()

    //Functions

 const columns = [
    {
      title: 'No.',
      dataIndex: 'count',
      width: 40,
      render: (text: any, record: any, index: any) => {
          if ( transactions && (index === transactions?.length)) {
              return <strong>Total</strong>;
          }
          return index + 1;
      },
      className: 'count-column',
    },
    {
      title: 'Date',
      dataIndex: 'date_of_creation',
      key: 'date_of_creation',
      width: 120,
    },
    {
      title: 'Narration',
      dataIndex: 'narration',
      key: 'narration',
      width: 120,

    },
    {
      title: 'Debit',
      dataIndex: 'debit',
      key: 'debit',
      width: 120,
    },
    {
      title: 'Credit',
      dataIndex: 'credit',
      key: 'credit',
      width: 120,
    
    },
    {
      title: 'Balance',
      dataIndex: 'correct_current_balance',
      key: 'correct_current_balance',
      width: 120,

    },

];


    //Components

   const exportToExcel = () => {
      const fileName = 'dlms_data.xlsx';
      const table = document.getElementById('rpms-data-table');
      const clonedTable = table?.cloneNode(true) as HTMLTableElement;
      const excludedColumnIndices = [7];
      clonedTable.querySelectorAll('tr').forEach(row => {
        excludedColumnIndices.forEach(index => {
          row.deleteCell(index);
        });
      });

      const worksheet = XLSX.utils.table_to_sheet(clonedTable);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, fileName);
    }



 const getIdTypes = async()=> {
    
    const response = await axios.get(`${AUTH_URL}/meta/id-types`, {withCredentials: true})
    if(response.data.success){
        setIdTypes(response.data.id_types)
    }else{
      notify('There are no ID types in the database', toastStyle)
    }
    }

     //Submit

  const submit = async ()=>{
    
    setSearching(true)
        const response = await axios.post(`${AUTH_URL}/statements`, {client: marchedClient}, {withCredentials: true})
        setSearching(false)
        if(response.data.success){
            notify_success(`${response.data.message}`, toastStyle)
            setTransactions(response.data.transactions)
            setClient(response.data.client)
            setSummary(response.data.summary)
        }

        if(!response.data.success){
            notify(`${response.data.message}`, toastStyle)
        }
  } 

  const searchClients = (value: string, callback: Function) => {
        axios.post(`${AUTH_URL}/clients/search`, {name: value}, {withCredentials: true})
            .then((response) => {
            const data = response.data.clients.map((client: IClient) => ({
                value: client._id,
                text: `${client.surname} ${client.given_name} (${client.phone})`,
            }))
            callback(data)
            })
            .catch((error) => {
            notify(`${error.message}`, toastStyle)
            callback([])
            })
        }
    
  const handleSearchClient = (newValue: string) => {
    searchClients(newValue, setClients)
  }

  useEffect(()=>{
    getIdTypes()

  }, [dispatch, dateRange])

  return (
    <>
    <Row>
        <Col>
                <Form
                  className='py-0'
                  layout="horizontal"
                  form={form}
                  name="control-hooks"
                  onFinish={submit}

                    >
                    <Row className='py-2 border'>
                      
                    <Col lg={8} md={12}>
                        <Form.Item
                        className='my-0'
                        label="SEARCH CLIENT"
                        name="client"
                        rules={[{ required: true, message: "Client is required" }]}
                        >
                        <Select
                          showSearch
                          placeholder="Enter client's surname, given name or phone number to search"
                          defaultActiveFirstOption={false}
                          suffixIcon={null}
                          filterOption={false}
                          onSearch={handleSearchClient}
                          notFoundContent={null}
                          options={(clients || []).map((client) => ({
                            value: client.value,
                            label: client.text,
                          }))}
                          allowClear
                          onChange={setMarchedClient}
                        />
                        </Form.Item>
                    </Col>
                    <Col>
                    <Button
                     className='rounded-0 text-uppercase'
                     htmlType='submit'
                     type='primary'
                     loading={searching}
                     > <SearchOutlined>
                      </SearchOutlined> 
                      {
                        searching ?
                      'Getting statement...'
                      :
                      'Get Statement'

                      }
                      
                      </Button>
                    
                    </Col>
                  
                  </Row>
                  
                </Form>
        
        
        </Col>
        
        </Row>
    {transactions? 
    <Row>
    
     {
      (transactions && client) &&

      <Row className='my-4'>
      <Col className='my-2'>
        <Row className='rounded-0 p-0 d-flex flex'>
    
              <p className='small lh-1'> <span className='fw-bold'>CLIENT:</span> {client.surname} {client.given_name}</p>
              <p className='small lh-1'> <span className='fw-bold'>BRANCH</span>: {client.branch.toLocaleUpperCase()}</p>
              <p className='small lh-1'> <span className='fw-bold'>AS OF</span>: {new Date().toLocaleString()}</p>
          
        </Row>
      
      </Col>
      <Table 
        pagination={false} 
        className='rounded-0 transactions-table no-top-radius' 
        id='dlms-statement-table' 
        bordered 
        tableLayout='fixed'
        style={{overflow: 'auto'}} 
        dataSource={[
          ...transactions,
          {
              count: transactions.length,
              credit: summary?.totalCredit,
              debit: summary?.totalDebit,
              correct_current_balance: summary?.balance,
              isTotalRow: true,
          },
      ]}
        columns={columns} 
        rowClassName={(record: any, index: number) =>
            record.isTotalRow ? 'total-row' : ''
        }
        title={() =><Row className='d-flex flex justify-content-between align-items-center'> 
        <Col>
          <span className='fw-bold py-0'>FINANCIAL STATEMENT</span>
        </Col>
        <Col className='d-flex flex justify-content-end'> 
          <PDFDownloadLink
            document={<PDFViewer transactions={transactions} summary={summary} agent={userDetails} client={client}  />}
            fileName={`${client.surname.toUpperCase()}-${client.given_name.toUpperCase()}-financial-statement.pdf`}
            >
              <Button  
                className='rounded-0 text-uppercase'
              >
              <LiaDownloadSolid />
                Download Statement
              </Button>
          </PDFDownloadLink>
          </Col>
          </Row>}
       />
       </Row>

     }
     
      
      </Row> : 
        <></>

    }
    </>
  )
}

export default StatementTable